import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosArrowForward } from "react-icons/io";

const Customization = () => {
  const data = [
    {
      img: "/assets/sp1.webp",
      head: "Health care – HIMS, EMR & EHR",
      paras: [
        "Modern medical evolution demands the effective union of technological platforms for hospitals to provide efficient healthcare operations. Among our Healthcare IT solutions we provide adaptable Hospital Information Management Systems (HIMS) and Electronic Medical Records (EMR) solutions which suit these departments including hospitals, clinics and diagnostic centers.",
        "The secure access to patient information in combination with note updating and prescription writing functions and test result monitoring through EMR systems provides healthcare specialists with better diagnostic capabilities and improved decision support. Under the HIMS platform Healthcare process solutions provide comprehensive hospital operation capabilities which range from pharmacy to inventory management and administrative controls and discharge management.",
        "The healthcare software our company offers gives staff empowerment while advancing patient interactions and delivers operational superiority through automated data processing.",
      ],
    },
    {
      img: "/assets/sp2.webp",
      head: "Real Estate – CRM",
      paras: [
        "Real estate business expansion becomes challenging when leads together with properties as well as communications extend beyond multiple channels. The CRM solution built specifically for the real estate industry enables streamlined centralized management of client-relations and customer sales operations.",
        "This CRM system allows you to handle property listings by uploading images and adding specifications as well as pricing and making availability updates while building complete records of client activities and interaction histories.",
        "The system offers customized dashboards together with analytical tools which reveal performance metrics to support data-based decision making.",
      ],
    },
    {
      img: "/assets/sp3.webp",
      head: "Finance Books",
      paras: [
        "Every business success requires robust financial management which our highly effective Finance Software Solutions were developed to guide businesses toward stronger accounting and financial compliance performance.",
        "The software Shows support for payroll operations and asset management features alongside providing audit trail functionality which enables full visibility and control of all financial activities.",
        "Our platform connects companies to banks as well as mutually supports ERP solutions and common payment gateway networks to form smooth financial systems. Real-time analytics generate graphical indicators and AI-detection features combined with immediate detection alerts help you recognize financial patterns better to respond correctly to market indicators.",
      ],
    },
    {
      img: "/assets/sp4.webp",
      head: "E-commerce - Dashboard",
      paras: [
        "A prosperous e-commerce venture demands more than simply attractive website design as it needs an integrated digital system that ensures remarkable user interaction and revenue generation and systematizes back-end operations.",
        "A store owner can use the admin dashboard to track live performance data, handle customer messages, control inventory and orders, develop special offers and view analytics about user behavior and sales activity.",
        "The platform's scalable framework facilitates swelling brand operations while delivering integration to main CRM applications and enterprise resource platforms and delivery service networks.",
      ],
    },
    {
      img: "/assets/sp5.webp",
      head: "Education - LMS",
      paras: [
        "Education institutions together with their educators and students will find comprehensive power in our digital solutions for the changing education sector. Our software helps all educational institutions including schools and colleges and coaching centers as well as ed-tech startups streamline academic procedures and administrative work.",
        "The system features an entire Learning Management System (LMS) that enables course hosting along with material sharing while facilitating assessments and student progress tracking.",
        "The designated portal and mobile app lets parents stay current with their child’s academic achievements and payment information and school declarations. Under this platform teachers carry out live classes through integrated services based on Zoom or Google Meet and access detailed insights with analytics reports.",
      ],
    },
    {
      img: "/assets/sp6.webp",
      head: "Payroll Management",
      paras: [
        "Managing employee salaries, taxes, and compliance manually can be time-consuming and error-prone. The Payroll Management Software through our company provides automated capabilities for salary processing along with tax deductions and provident fund contributions followed by payslip output.",
        "The software system enables users to handle multi-site payroll processing while performing calculations based on shifts and processing bonuses and arrears alongside reimbursements.",
        "Spreadsheets should be eliminated because businesses need a secure automated method to simplify their payroll management.",
      ],
    },
  ];

  const [index, setIndex] = useState(0);

  const handleForward = () => {
    setIndex((prev) => (prev + 1) % data.length);
  };

  const handleBack = () => {
    setIndex((prev) => (prev - 1 + data.length) % data.length);
  };
  return (
    <>
      <section className="pt-100 pb-100" style={{ backgroundColor: "#fff" }}>
        <div className="container">
          <div className="section-title mb-45 text-center">
            <span className="sub-title mb-15">\ Customization \</span>
            <h2 className="m-auto" style={{ width: "60%" }}>
              Custom Software Solutions for Every Industry
            </h2>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 pb-2">
              <AnimatePresence mode="wait">
                <motion.img
                  key={data[index].img}
                  src={data[index].img}
                  className="img-fluid"
                  alt="img"
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                  }}
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 50 }}
                  transition={{ duration: 0.5 }}
                />
              </AnimatePresence>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12 movediv">
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="sub-sks">{data[index].head}</span>
                  <div className="text-end" style={{width:"20%"}}>
                    <IoIosArrowForward
                      style={{
                        transform: "rotate(180deg)",
                        cursor: "pointer",
                        color: "#333",
                      }}
                      className="nav-icon"
                      onClick={handleBack}
                    />
                    <IoIosArrowForward
                      className="ms-2 nav-icon"
                      style={{ cursor: "pointer", color: "#333" }}
                      onClick={handleForward}
                    />
                  </div>
                </div>
                <hr style={{ height: "3px" }} />
                <AnimatePresence mode="wait">
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                  >
                    {data[index].paras.map((para: any, i: any) => (
                      <p key={i}>{para}</p>
                    ))}
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Customization;
